import React, { useState } from 'react';
import Firebase from 'firebase';

const FileUploader = ({ userId }) => {
  const [inputRef, setInputRef] = useState(null);
  const [progress, setProgress] = useState(false);
  const [imgFile, setImgFile] = useState('');
  const [fileName, setFileName] = useState('');
  const [fileExt, setFileExt] = useState('');
  const [error, setError] = useState('');
  const handleFileUpload = () => {
    var storageRef = Firebase.storage().ref();
    var ref = storageRef.child(`cvs/${userId}.${fileExt}`);
    setProgress(true);
    ref.put(imgFile)
      .then(function (snapshot) {
        snapshot.ref.getDownloadURL()
          .then(function (downloadURL) {
            setProgress(false);
            setImgFile(null);
            setError('Votre condidature a été enregistrée')
          });
      }).catch(error => {
        setError('Erreur !');
        setProgress(false);
        setImgFile(null);
      });
  }


  const handleFileInputChange = (event) => {
    setError('');
    if (event.target.files && event.target.files.length && event.target.files[0]) {
      const file = event.target.files[0];
      const parts = file.name.split('.');
      const ext = parts[parts.length - 1];
      if (!['pdf', 'doc', 'docx', 'png', 'jpg', 'jpeg'].includes(ext.toLowerCase())) {
        setError('Error: only : pdf, doc, docx, png, jpg, jpeg are allowed');
        return;
      } else {
        setFileExt(ext.toLowerCase());
      }
      if (file.size > 2000000) {
        setError('Error: Max file size 2 Mega');
        return;
      }
      setFileName(file.name);
      setImgFile(file);
    }
  }

  return (<>
    <div className="file-upload">
      <div className="file-input-wrapper">
        <button className="plain-btn" onClick={() => inputRef ? inputRef.click() : null} style={{ cursor: 'pointer', borderRadius: '5px' }}>Choisir un Fichier</button>
        <input ref={setInputRef} type="file" onChange={handleFileInputChange} style={{ display: 'none' }} />
      </div>
      {fileName ? <p>{fileName}</p> : null}
      {!error && imgFile && !progress ? (
        <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center' }}>
          <button className="pri-btn" onClick={handleFileUpload} style={{ cursor: 'pointer', width: '300px', marginTop: '20px' }}>Envoyer</button>
        </div>) :
        null}
      {error ? <p className="error">{error}</p> : null}
      {!error && progress ? (
        <div className="loading-icon" style={{ fontSize: '70px', margin: 0, padding: 0, lineHeight: 0 }}>
          <span style={{ animation: 'blinker 1s linear infinite', animationDelay: '0s' }}>.</span>
          <span style={{ animation: 'blinker 1s linear infinite', animationDelay: '.3s' }}>.</span>
          <span style={{ animation: 'blinker 1s linear infinite', animationDelay: '.6s' }}>.</span>
        </div>)
        : null}
    </div>
  </>)

}

export default FileUploader;